export default {
  submitBtn: false,
  emptyBtn: false,
  group: [
    {
      label: '房产信息',
      prop: 'group1',
      column: [
        {
          label: '主键/房产编号',
          prop: 'id',
          display: false,
          rules: [
            {
              required: true,
              message: '请输入主键/房产编号',
              trigger: 'change',
            },
          ],
        },
        {
          label: '上级节点id',
          prop: 'parentId',
          display: false,
          readonly: true,
          span: 8,
        },
        {
          label: '上级节点',
          prop: 'parentObjectName',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '上级属性',
          prop: 'parentObjectTypeName',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '本级属性',
          prop: 'objectType',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [{ required: true, message: '请输入本级属性', trigger: 'change' }],
          span: 8,
        },
        {
          label: '节点编码',
          prop: 'objectCode',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '速记码',
          prop: 'shortCode',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '房间号',
          prop: 'objectName',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '排序序号',
          prop: 'indexNum',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '节点名称',
          prop: 'objectFullName',
          display: true,
          disabled: true,
          span: 24,
        },
        {
          label: '房产地址',
          prop: 'roomName',
          display: true,
          disabled: true,
          span: 24,
        },
        {
          label: '建筑面积',
          prop: 'floorage',
          display: true,
          disabled: true,
          placeholder: '请输入 建筑面积，单位m2',
          span: 8,
        },
        {
          label: '使用面积',
          prop: 'usableArea',
          display: true,
          disabled: true,
          placeholder: '请输入 建筑面积，单位m2',
          span: 8,
        },
        {
          label: '户型',
          prop: 'roomLayout',
          type: 'select',
          disabled: true,
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_layout',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '阁楼面积',
          prop: 'loftArea',
          display: true,
          disabled: true,
          placeholder: '请输入 建筑面积，单位m2',
          span: 8,
        },
        {
          label: '车位面积',
          prop: 'parkingArea',
          display: true,
          disabled: true,
          placeholder: '请输入 建筑面积，单位m2',
          span: 8,
        },
        {
          label: '加建面积',
          prop: 'additionArea',
          display: true,
          disabled: true,
          placeholder: '请输入 建筑面积，单位m2',
          span: 8,
        },
        {
          label: '房屋状态',
          prop: 'roomStatus',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_status',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '房屋性质',
          prop: 'useType',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=use_type',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '朝向',
          prop: 'roomOrientations',
          type: 'select',
          disabled: true,
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_orientations',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '用途',
          prop: 'useDesc',
          disabled: true,
          display: true,
          span: 16,
        },
        {
          label: '房屋类型',
          prop: 'roomType',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=room_type',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
      ],
    },
    {
      label: '户主信息',
      prop: 'group2',
      column: [
        {
          label: '户主姓名',
          prop: 'householdName',
          disabled: true,
          display: true,
          span: 8,
        },
        {
          label: '性别',
          prop: 'householdSex',
          disabled: true,
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=sex',
          props: { label: 'dictValue', value: 'dictKey' },
          span: 8,
        },
        {
          label: '联系电话',
          prop: 'householdLinkPhone',
          display: true,
          disabled: true,
          span: 8,
        },
        {
          label: '身份证',
          prop: 'householdIdCard',
          disabled: true,
          display: true,
          span: 8,
        },
        {
          label: '邮箱',
          prop: 'householdEmail',
          disabled: true,
          display: true,
          span: 8,
        },
        {
          label: 'QQ',
          prop: 'householdQQ',
          display: true,
          disabled: true,
          span: 8,
        },
      ],
    },
    {
      // icon: 'el-icon-info',
      label: '公寓信息',
      prop: 'group3',
      display: false,
      column: [
        {
          label: '床位',
          type: 'number',
          prop: 'bedCapacity',
          disabled: true,
        },
        {
          label: '已用床位',
          type: 'number',
          prop: 'bedUsing',
          disabled: true,
        },
      ],
    },
    {
      label: '租赁信息',
      prop: 'group4',
      display: false,
      column: [
        {
          label: '总面积',
          prop: 'totalArea',
          disabled: true,
          placeholder: '请输入 总面积，单位m2',
          span: 8,
        },
        {
          label: '已用面积',
          prop: 'usedArea',
          disabled: true,
          placeholder: '请输入 已用面积，单位m2',
          span: 8,
        },
        {
          label: '可用面积',
          prop: 'availableArea',
          disabled: true,
          placeholder: '请输入 可用面积，单位m2',
          span: 8,
        },
      ],
    },
  ],
};
